export default __webpack_public_path__ + "static/media/013-oyster.24089915.svg";